import intlTelInput from 'intl-tel-input';
import helpers from '../helpers';
import popup from './popup';
import './intlTelInputUtils';

const pageClass = document.querySelector('body').classList;
const $form = document.querySelector('#request');

const utm = {
	utm_source: '{source}',
	utm_medium: 'cpc',
	utm_content: 'gid|{gbid}|ad_id|{ad_id}|phrase_id|{phrase_id}',
	utm_campaign: '{campaign_id}',
	utm_term: '{keyword}',
};

/* eslint-disable */
const _tmr = window._tmr || (window._tmr = []);

function gtag_report_conversion(url) {
	let callback = function () {
		if (typeof(url) != 'undefined') {
			window.location = url;
		}
	};

	// ga('send', 'event', {
	// 	eventCategory: 'conversion',
	// 	eventAction: 'conversion',
	// 	sendTo: 'AW-622861531/s6weCPH1toMDENu5gKkC',
	// 	eventCallback: callback,
	// });
	return false;
}
/* eslint-enable */
/* eslint-disable new-cap */
/* eslint-disable no-undef */

function showComment(e) {
	const wrapper = document.querySelector('.form__group--comment');
	const height = document.querySelector('.form__item--comment').clientHeight;

	if (e.target.value.length > 0) {
		wrapper.style.height = `${height + 1}px`;
	}
}

function setValuesCompanny(data) {
	const name = document.querySelector('#headName');
	const company = document.querySelector('#company');

	company.value = data.name.short_with_opf;

	company.classList.add('is-active', 'valid');
	company.classList.remove('error');

	if (name) {
		name.value = data.inn.length === 10 ? data.management.name : data.name.full;

		name.classList.add('is-active', 'valid');
		name.classList.remove('error');
	}
}

function cleanValusCompany() {
	const name = document.querySelector('#headName');
	const company = document.querySelector('#company');

	company.value = '';

	company.classList.remove('is-active');

	if (name) {
		name.value = '';
		name.classList.remove('is-active');
	}
}

// function setErrorLableInn() {
// 	const label = document.createElement('label');
// 	label.classList.add('error');
// 	label.setAttribute('for', 'inn');
// 	label.id = 'inn-error';
// 	document.getElementById('inn').parentNode.appendChild(label);

// 	label.innerText = 'Неверно указан ИНН';
// 	label.style.display = 'block';
// }

const Analytics = {
	reachGoal: (target) => {
		if (typeof window.ym === 'function') {
			window.ym(25538402, 'reachGoal', target);
		}
	},
	push: (event) => {
		if (typeof window.dataLayer === 'undefined') {
			window.dataLayer = [];
		}

		window.dataLayer.push(event);
	},
};

function sendAjaxForm(form, url) {
	let isResident = false;
	let dataParams = new FormData();
	let messages = {
		success: '<p>Спасибо, что заполнили форму!</p><p>Мы скоро с вами свяжемся</p>',
		error_message: '<p>Ошибка!</p>',
		error: '<p>Что-то пошло не так!</p><p>Попробуйте повторить</p>',
	};

	for (const pair of new FormData(form)) {
		dataParams.append(pair[0], pair[1]);

		if (pair[0] === 'resident' && pair[1] === 'yes') {
			isResident = true;
		}

		if (pair[0] === 'resident' && pair[1] === 'online-kassa') {
			isResident = 'online-kassa';
		}
	}

	for (let i = 0; i < localStorage.length; i++) {
		let key = localStorage.key(i);

		dataParams.append(key, localStorage.getItem(key));
	}

	let request = new XMLHttpRequest();
	request.open('POST', url, true);
	request.addEventListener('load', function () {
		if (this.status >= 200 && this.status < 400) {
			let response = JSON.parse(this.response);
			if (response.status === 'success') {
				form.reset();
				popup.openPopup(messages.success);
				gtag_report_conversion();

				if (typeof response.lead.result.dealId !== 'undefined') {
					if (isResident === true) {
						// Форма Резиденты
						// MyTarget
						_tmr.push({
							type: 'reachGoal',
							id: 3179978,
							goal: 'Lead',
						});

						// ga('send', 'universal_event', {
						// 	eventCategory: 'GA_Form',
						// 	eventAction: 'GA_submit',
						// 	universal_event_systems: 'GA_FP_YM',
						// 	eventLabel: 'submit_form_connection',
						// 	userId: response.lead.result.dealId,
						// });
					} else if (isResident === 'online-kassa') {
						// Форма online-kassa
						_tmr.push({
							type: 'reachGoal',
							id: 3179978,
							goal: 'lead_kassa',
						});

						Analytics.reachGoal('formleadkassir');

						// ga('send', 'event', 'lead', 'form', 'kassir');
					} else {
						// Форма Нерезиденты
						_tmr.push({
							type: 'reachGoal',
							id: 3179978,
							goal: 'lead_nonresidents',
						});

						Analytics.reachGoal('formleadnonresident');

						// ga('send', 'event', 'lead', 'form', 'nonresident');

						// ga('send', 'universal_event', {
						// 	eventCategory: 'GA_Form',
						// 	eventAction: 'GA_submit',
						// 	universal_event_systems: 'GA_FP_YM',
						// 	eventLabel: 'submit_form_connection_nonresidents',
						// 	userId: response.lead.result.dealId,
						// });
					}

					VK.Goal('lead');

					switch (true) {
						case pageClass.contains('page-form-residents'):
							// Отправка формы заявки со страницы резиденты
							Analytics.reachGoal('formleadresidents');
							// ga('send', 'event', 'lead', 'form', 'residentpage');
							break;
						case pageClass.contains('page-home'):
							// Отправка формы заявки главная страница
							Analytics.reachGoal('formleadmainpage');
							// ga('send', 'event', 'lead', 'form', 'resident');
							break;
						case pageClass.contains('page-public'):
							// Отправка формы заявки общественное питание
							Analytics.reachGoal('formleadfood');
							// ga('send', 'event', 'lead', 'form', 'food');
							break;
						case pageClass.contains('page-ecommerce'):
							// Отправка формы заявки E-commerce
							Analytics.reachGoal('formleadecommerce');
							// ga('send', 'event', 'lead', 'form', 'ecommerce');
							break;
						case pageClass.contains('page-finance'):
							// Отправка формы заявки Онлайн платежи в финансах
							Analytics.reachGoal('formleadfinance');
							// ga('send', 'event', 'lead', 'form', 'finance');
							break;
						case pageClass.contains('page-entertainment'):
							// Отправка формы заявки Онлайн платежи сфера развлечений
							Analytics.reachGoal('formleadenvironment');
							// ga('send', 'event', 'lead', 'form', 'environment');
							break;
						case pageClass.contains('page-edu'):
							// Отправка формы заявки Онлайн платежи образование
							Analytics.reachGoal('formleadeducation');
							// ga('send', 'event', 'lead', 'form', 'education');
							break;
						default:
							// do nothing
					}
				}
			} else {
				popup.openPopup(`${messages.error_message}<p>${response.message}</p>`);
			}
		} else {
			popup.openPopup(messages.error);
		}
	});

	request.addEventListener('error', () => {
		popup.openPopup(messages.error);
	});

	request.send(dataParams);
}


function checkNumber(value) {
	const val = value.replace(/[^+\d]/g, '');

	switch (true) {
		// Rus and Kz
		case val.includes('+7') && val.length >= 11:
			return true;
		// Belarus
		case val.includes('+375') && val.length >= 11:
			return true;
		// Latvia
		case val.includes('+371') && val.length >= 11:
			return true;
		// Estonia
		case val.includes('+372') && val.length >= 11:
			return true;
		// Lithuania
		case val.includes('+370') && val.length >= 11:
			return true;
		// Indonesia
		case val.includes('+62') && val.length >= 11:
			return true;
		// Thailand
		case val.includes('+66') && val.length >= 11:
			return true;
		// Singapore
		case val.includes('+65') && val.length >= 11:
			return true;
		// China
		case val.includes('+86') && val.length >= 11:
			return true;
		// Hong Kong and Taiwan
		case val.includes('+852') && val.length >= 11:
			return true;
		// Norway
		case val.includes('+472') && val.length >= 11:
			return true;
		// India
		case val.includes('+91') && val.length >= 11:
			return true;
		default: return false;
	}
}

function changeInputMask(e) {
	const val = e.target.value.replace(/[^+\d]/g, '');

	switch (true) {
		// Rus and Kz
		case val.includes('+7') :
			Inputmask({
				mask: '+9 (999) 999-99-99',
			}).mask('#phone');
			break;
		// Belarus
		case val.includes('+375') || val.includes('+380'):
			Inputmask({
				mask: '+999 (99) 999-99-99',
			}).mask('#phone');
			break;
		// Latvia
		case val.includes('+371') || val.includes('+357'):
			Inputmask({
				mask: '+999 (99) 999-999',
			}).mask('#phone');
			break;
		// Estonia
		case val.includes('+372') :
			Inputmask({
				mask: '+999 9999-9999',
			}).mask('#phone');
			break;
		// Lithuania
		case val.includes('+370') || val.includes('+972'):
			Inputmask({
				mask: '+999 (99) 999-999',
			}).mask('#phone');
			break;
		// Indonesia
		case val.includes('+62') :
			Inputmask({
				mask: '+99 (999) 999-99-99',
			}).mask('#phone');
			break;
		// Thailand
		case val.includes('+66') :
			Inputmask({
				mask: '+99 (99) 999-99-99',
			}).mask('#phone');
			break;
		// Singapore
		case val.includes('+65') :
			Inputmask({
				mask: '+99 9999-99-99',
			}).mask('#phone');
			break;
		// China
		case val.includes('+86') :
			Inputmask({
				mask: '+99 (999) 9999-99-99',
			}).mask('#phone');
			break;
		// Hong Kong and Taiwan
		case val.includes('+852') || val.includes('+886'):
			Inputmask({
				mask: '+999 9999-99-99',
			}).mask('#phone');
			break;
		// Norway
		case val.includes('+472'):
			Inputmask({
				mask: '+999 (999) 999-99-99',
			}).mask('#phone');
			break;
		// India
		case val.includes('+91'):
			Inputmask({
				mask: '+99 (9999) 999-999',
			}).mask('#phone');
			break;
		default: Inputmask({
			mask: '+9 (999) 999-99-99',
		}).mask('#phone');
	}
}

/**
 * Получение GET параметра из url
 * @param string name
 * @return string|null
 */

function getUrlParam(name) {
	let params = [];

	window.location.search.substring(1).split('&').forEach((param) => {
		param = param.split('=');
		if (param[0] && param[1]) {
			params[param[0]] = param[1];
		}
	});

	return typeof params[name] !== 'undefined' ? params[name] : null;
}

function containerLockScrollOnHover(element) {
	element.addEventListener('mouseenter', () => {
		if (window.scrollbar) {
			window.scrollbar.updatePluginOptions('modal', {open: true});
		}
	});

	element.addEventListener('mouseleave', () => {
		if (window.scrollbar) {
			window.scrollbar.updatePluginOptions('modal', {open: false});
		}
	});
}

const init = () => {
	if ($form) {
		// eslint-disable-next-line
		for (let key in utm) {
			if (getUrlParam(key) !== null) {
				localStorage.setItem(key, getUrlParam(key));
			}
		}

		Inputmask({
			mask: '+9 (999) 999-9999',
		}).mask('#phone');

		helpers.$document
			.on('focus', '.form__input', (e) => {
				$(e.currentTarget).addClass('is-active');
				$(e.currentTarget).closest('.form__item').addClass('is-active');
			})
			.on('blur', '.form__input', (e) => {
				if ($(e.currentTarget).val() < 1) {
					$(e.currentTarget).removeClass('is-active');
					$(e.currentTarget).closest('.form__item').removeClass('is-active');
				}

				if (e.target.id === 'inn' && e.target.value.length > 0 || e.target.id === 'registrationNumber' && e.target.value.length > 0) {
					// getCompanyByINN(e);
				}
			})
			.on('input', '#phone', changeInputMask)
			.on('change', 'input[name="preference"]', showComment);

		const phoneInputID = '#phoneNoResident';
		const $phoneNoResident = document.querySelector(phoneInputID);

		if ($phoneNoResident) {
			const label = document.querySelector('label[for="phoneNoResident"]');

			const labelLeft = () => {
				let paddingInput = $phoneNoResident.style.paddingLeft;
				label.style.left = paddingInput;
			};

			setTimeout(() => {
				const $iti = document.querySelector('.iti');

				$iti.append(label);
				labelLeft();
			}, 250);

			const iti = intlTelInput($phoneNoResident, {
				autoPlaceholder: 'aggressive',
				separateDialCode: true,
				nationalMode: false,
				hiddenInput: 'phoneNumber',
				localizedCountries: {
					at: 'Австрия',
					be: 'Бельгия',
					bg: 'Болгария',
					hu: 'Венгрия',
					de: 'Германия',
					gr: 'Греция',
					dk: 'Дания',
					ie: 'Ирландия',
					es: 'Испания',
					it: 'Италия',
					cy: 'Кипр',
					lv: 'Латвия',
					lt: 'Литва',
					lu: 'Люксембург',
					mt: 'Мальта',
					nl: 'Нидерланды',
					no: 'Норвегия',
					pl: 'Польша',
					pt: 'Португалия',
					ro: 'Румыния',
					sk: 'Словакия',
					si: 'Словения',
					tr: 'Турция',
					ua: 'Украина',
					fi: 'Финляндия',
					fr: 'Франция',
					hr: 'Хорватия',
					cz: 'Чехия',
					se: 'Швеция',
					ee: 'Эстония',
				},
				onlyCountries: [
					'at', 'be', 'bg', 'hu', 'de', 'gr', 'dk', 'ie', 'es', 'it', 'cy', 'lv', 'lt', 'lu', 'mt', 'nl', 'no', 'pl', 'pt', 'ro', 'sk', 'si', 'tr', 'ua', 'fi', 'fr', 'hr', 'cz', 'se', 'ee',
				],
				customPlaceholder: (selectedCountryPlaceholder) => {
					return selectedCountryPlaceholder.replace(/[0-9]/g, '_');
				},
				utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/js/utils.min.js',
			});

			containerLockScrollOnHover(iti.countryList);

			$(phoneInputID).on('focus click countrychange', function () {
				let thisPlacholder = $(this).attr('placeholder');
				let res = thisPlacholder.replace(/_/g, '9');

				if (res !== 'undefined') {
					Inputmask(res, {
						placeholder: '_',
						clearMaskOnLostFocus: true,
						keepStatic: true,
					}).mask(this);

					labelLeft();
				}
			});

			$phoneNoResident.addEventListener('focusout', () => {
				let countryData = iti.getSelectedCountryData();
				let inputNonResidentCountryCode = document.querySelector('#nonResidentCountryCode');

				inputNonResidentCountryCode.value = countryData.iso2.toUpperCase();
			});

			$phoneNoResident.addEventListener('open:countrydropdown', () => {
				$phoneNoResident.closest('.form__item').classList.add('is-active');
			});

			$phoneNoResident.addEventListener('close:countrydropdown', () => {
				$phoneNoResident.closest('.form__item').classList.remove('is-active');
			});

			$.validator.addClassRules({
				phoneNoResident: {
					required: 'Введите номер телефона',
					phoneNumValidation: '',
				},
			});

			// eslint-disable-next-line
			$.validator.addMethod("phoneNumValidation", function(value, element) {
				// return iti.isValidNumber();

				value = value.replace(/_/g, '');
				value = value.replace(/\s+/g, '');

				return value.length > 6;
			}, 'Неверно указан телефон');
		} else {
			// eslint-disable-next-line
			$.validator.addMethod('validationNumber', function(value, element) {
				return this.optional(element) || checkNumber(value);
			}, 'Неверно указан телефон');
		}

		$('#request').validate({
			rules: {
				site: {
					required: true,
				},
				inn: {
					required: true,
				},
				registrationNumber: {
					required: true,
				},
				company: {
					required: true,
				},
				headName: {
					required: true,
				},
				Firstname: {
					required: true,
				},
				email: {
					required: true,
					email: true,
				},
				phone: {
					required: true,
					validationNumber: '',
				},
			},
			messages: {
				site: 'Введите адрес сайта',
				inn: 'Заполните ИНН',
				registrationNumber: 'Заполните ИНН',
				company: 'Заполните это поле',
				headName: 'Заполните это поле',
				Firstname: 'Заполните это поле',
				email: {
					required: 'Вы не ввели e-mail адрес',
					email: 'Некорректный e-mail адрес',
				},
				phone: {
					required: 'Введите номер телефона',
					minlength: 'Номер телефона должен состоять минимум из 5 цифр',
				},
			},
			submitHandler: (form) => {
				sendAjaxForm(form, '/ajax/send.php');

				return false;
			},
		});
	}
};

export default {
	init,
};
